import { useWindowSize } from "@vueuse/core";
import { computed } from "vue";
const thresholds = {
    xs: 0,
    sm: 480,
    md: 715,
    lg: 880,
    xl: 1400,
    mobile: 479,
    compact: 789
};
export const useDisplay = () => {
    const { sm, md, lg, xl, compact, mobile } = thresholds;
    const { height, width } = useWindowSize({ listenOrientation: true });
    const isMobile = computed(() => width.value <= mobile);
    const isCompact = computed(() => width.value <= compact);
    const breakpoint = computed(() => {
        if (width.value < sm)
            return "xs";
        if (width.value < md)
            return "sm";
        if (width.value < lg)
            return "md";
        if (width.value < xl)
            return "lg";
        return "xl";
    });
    return {
        height,
        width,
        isMobile,
        isCompact,
        breakpoint
    };
};
export default { useDisplay };
